// Redux Toolkit
import { combineReducers, configureStore } from '@reduxjs/toolkit'

// Redux Persist
import {
    FLUSH,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
    REHYDRATE,
    persistReducer,
    persistStore,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import { paladinSlice } from './slices/paladin'
import { insuranceSlice } from './slices/insurance'
import { faceTecSlice } from './slices/facetec'
import { incomeSlice } from './slices/income'
import { assureSlice } from './slices/assure'

const combinedReducers = combineReducers({
    paladinReducer: paladinSlice.reducer,
    insuranceReducer: insuranceSlice.reducer,
    faceTecReducer: faceTecSlice.reducer,
    incomeReducer: incomeSlice.reducer,
    assureReducer: assureSlice.reducer,
})

const persistedReducer = persistReducer(
    {
        key: 'root',
        storage,
        whitelist: ['authReducer'],
    },
    combinedReducers
)

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
})

export const persistor = persistStore(store)

//export type OurStore = ReturnType<typeof store.getState>
//export type MyThunkDispatch = typeof store.dispatch